var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import flatten from 'lodash/flatten';
import { get } from '../tools/utils';
export var toOption = function (option, optionId, labelKey, valueKey) {
    return {
        label: option[labelKey],
        value: option[valueKey],
        id: optionId,
        type: 'option',
        disabled: option.disabled,
    };
};
export var getParsedOptions = function (options, labelKey, valueKey) {
    return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
            /* Group */
            var children = item.options.map(function (option, i) {
                return toOption(option, "".concat(itemIndex, "-").concat(i), labelKey, valueKey);
            });
            if (children.length) {
                return __spreadArray(__spreadArray([], __read(acc), false), [
                    {
                        type: 'group',
                        options: children,
                        label: item.label,
                        groupId: itemIndex,
                    },
                ], false);
            }
        }
        var option = toOption(item, "".concat(itemIndex), labelKey, valueKey);
        return __spreadArray(__spreadArray([], __read(acc), false), [option], false);
    }, []);
};
export var mapOptionsGroupValues = function (option, valueKey) {
    if (valueKey === void 0) { valueKey = 'value'; }
    var safeOpts = option.options || [];
    return safeOpts.map(function (opt) { return opt[valueKey]; });
};
export var gatherValues = function (options, valueKey) {
    if (valueKey === void 0) { valueKey = 'value'; }
    var vals = options.map(function (option) {
        var isUndef = option[valueKey] === undefined;
        if (!isUndef) {
            return option[valueKey];
        }
        return mapOptionsGroupValues(option, valueKey);
    });
    return flatten(vals);
};
export var mapOptionsGroupLabels = function (option, labelKey) {
    if (labelKey === void 0) { labelKey = 'label'; }
    var safeOpts = option.options || [];
    return safeOpts.map(function (opt) { return opt[labelKey]; });
};
export var gatherLabels = function (options, labelKey) {
    if (labelKey === void 0) { labelKey = 'label'; }
    var labels = options.map(function (option) {
        var isUndef = option[labelKey] === undefined;
        if (!isUndef) {
            return option[labelKey];
        }
        return mapOptionsGroupLabels(option, labelKey);
    });
    return flatten(labels);
};
export var getFill = function (props) {
    return props.disabled
        ? get.colors('slate-3')(props)
        : get.colors('bluesuedeshoes')(props);
};
//# sourceMappingURL=utils.js.map